module.exports = __webpack_public_path__ + "static/img/wxfwh.a43a999.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wxfwh.jpeg
// module id = QlXF
// module chunks = 1